import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { designTokens } from '../tokens';
import { InteractiveCard } from './InteractiveCard';
import { cardSurfaceStyles } from './cardSurface';

export type MetricCardProps = {
  label: ReactNode;
  value: ReactNode;
  description?: ReactNode;
  onClick?: () => void;
};

export function MetricCard({ label, value, description, onClick }: MetricCardProps) {
  const content = <>
      <Typography variant="body2" color="text.secondary">{label}</Typography>
      <Typography sx={{ ...designTokens.typography.metricValue, fontWeight: 700, my: 0.5, overflowWrap: 'anywhere' }}>{value}</Typography>
      {description ? <Typography variant="caption" color="text.secondary">{description}</Typography> : null}
    </>;
  const contentSx = {
    width: '100%',
    height: '100%',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    p: `${designTokens.layout.surfacePaddingCompact}px`,
    color: 'text.primary',
    textAlign: 'left',
  } as const;

  if (!onClick) return <Box sx={{ ...cardSurfaceStyles, ...contentSx }}>{content}</Box>;

  return <InteractiveCard onClick={onClick} sx={contentSx}>
    {content}
  </InteractiveCard>;
}
